module.exports = __webpack_public_path__ + "media/images/payment-providers/paypal-card-04c43e6018c6ad4b5da5738ef30b02ed.svg";